import { render, staticRenderFns } from "./cars.vue?vue&type=template&id=8ae00cf8&scoped=true"
import script from "./cars.vue?vue&type=script&lang=js"
export * from "./cars.vue?vue&type=script&lang=js"
import style0 from "./cars.vue?vue&type=style&index=0&id=8ae00cf8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae00cf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ae00cf8')) {
      api.createRecord('8ae00cf8', component.options)
    } else {
      api.reload('8ae00cf8', component.options)
    }
    module.hot.accept("./cars.vue?vue&type=template&id=8ae00cf8&scoped=true", function () {
      api.rerender('8ae00cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/cars.vue"
export default component.exports